import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

const TermsOfUse = () => {
  return (
    <div className="min-h-screen bg-background py-8">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="mb-8">
          <Link 
            to="/" 
            className="inline-flex items-center text-pink-600 hover:text-pink-700 mb-4 transition-colors duration-200"
          >
            <ArrowLeft className="h-4 w-4 mr-2" />
            Volver al inicio
          </Link>
          <h1 className="text-3xl font-bold text-text mb-2">Términos de Uso</h1>
          <p className="text-gray-600">Última actualización: {new Date().toLocaleDateString('es-MX')}</p>
        </div>

        {/* Content */}
        <div className="bg-white rounded-lg shadow-lg p-8 prose prose-lg max-w-none">
          <div className="space-y-6">
            <section>
              <p className="text-gray-700 leading-relaxed">
                El Sitio Web de SolterosMexico.com (el "Servicio") es un servicio de información y comunicaciones en línea que se provee, siempre y cuando usted cumpla con los términos y condiciones que se indican a continuación, incluyendo todos los anexos adjuntos al presente. Al hacer uso de este sitio, Usted acepta regirse por este convenio, asi como los dictados en el Aviso de Privacidad.
              </p>
              <p className="text-gray-700 leading-relaxed mt-4">
                Sírvase leer este Convenio atentamente antes de obtener acceso o usar el Servicio. Al obtener acceso o usar el Servicio, usted queda obligado a cumplir con los términos y condiciones indicados a continuación.
              </p>
              <p className="text-gray-700 leading-relaxed mt-4">
                Si no está de acuerdo en cumplir con todos estos términos y condiciones, No debe obtener acceso al Servicio, ni usarlo.
              </p>
              <p className="text-gray-700 leading-relaxed mt-4">
                SolterosMexico.com puede modificar este Convenio en cualquier momento sin aviso previo, y dichas modificaciones entrarán en vigor inmediatamente después de anunciar el Convenio modificado. Usted conviene en revisar el Convenio periódicamente para estar al tanto de dichas modificaciones, y la continuación de su acceso al Servicio o de su uso se considerará como su aceptación concluyente del Convenio modificado.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-text mb-4">1. Normas de Operación</h2>
              <p className="text-gray-700 leading-relaxed">
                Usted conviene en cumplir con las Normas de Operación estipuladas en http://www.SolterosMexico.com (según sean enmendadas por SolterosMexico.com de cuando en cuando), que son las reglas que rigen su actividad en relación con el Servicio. SolterosMexico.com tiene el derecho, pero no la obligación, de remover cualesquiera comunicaciones y/o materiales alojados dentro de El Servicio, que SolterosMexico.com crea, a su sola discreción, que violan las Normas de Operación, o que afecten los intereses de La Empresa proveedora de El Servicio.
              </p>
              <ul className="list-disc list-inside text-gray-700 leading-relaxed mt-4 space-y-2">
                <li>SolterosMexico.com no será responsable de avisar ni de indemnizar a ninguna persona, fisica o moral, por alojar o remover información de nuestro servidor o sitio Web.</li>
                <li>La empresa se reserva el derecho de negar el servicio a cualquier persona, en cualquier momento, y por cualquier motivo, y Usted acepta esta premisa al abrir su cuenta.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-text mb-4">2. Derechos de Autor, Licencias y Presentación de Ideas</h2>
              <p className="text-gray-700 leading-relaxed">
                Este Sitio y el material contenido en el presente es propiedad de SolterosMexico.com y sus respectivos dueños. Reservados todos los Derechos. Usted no puede modificar, copiar, reproducir, transmitir, distribuir, publicar, crear obras derivadas, exhibir ni de otro modo transferir o explotar comercialmente ningún material contenido en este Sitio, en su totalidad o parcialmente; no obstante, usted puede copiar e imprimir un número razonable de copias del material de este Sitio sólo para fines personales o educativos no comerciales.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-text mb-4">3. Uso del Servicio</h2>
              <p className="text-gray-700 leading-relaxed">
                SolterosMexico.com no opera, controla ni se hace responsable bajo ningún concepto, de ninguna información, productos o servicios en Internet. Excepto por la información, los productos o los servicios identificados como autoria de SolterosMexico.com, toda información, productos y servicios ofrecidos a través del Servicio o en Internet en general son ofrecidos por terceros que no están afiliados a SolterosMexico.com.
              </p>
              <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 mt-4">
                <p className="text-yellow-800 font-medium">
                  EN NINGÚN CASO SolterosMexico.com O SUS DIRECTORES, EJECUTIVOS, EMPLEADOS, AFILIADOS O AGENTES SERÁN RESPONSABLES ANTE USTED O CUALQUIER TERCERO POR DAÑOS INCIDENTALES, INDIRECTOS, ESPECIALES O CONSECUENTES.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-text mb-4">4. Enlaces</h2>
              <p className="text-gray-700 leading-relaxed">
                Algunos enlaces de SolterosMexico.com conducen a sitios colocados por propietarios de sitios independientes. SolterosMexico.com no revisa los sitios independientes ni controla su contenido y meramente provee estos enlaces a los visitantes para su conveniencia.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-text mb-4">5. Indemnización</h2>
              <p className="text-gray-700 leading-relaxed">
                Usted conviene en indemnizar, defender y mantener a salvo a SolterosMexico.com, sus ejecutivos, directores, empleados, agentes, concesionarios, abastecedores y cualesquiera terceros proveedores de información al Servicio, de y contra todas las pérdidas, gastos, daños y costos, incluyendo honorarios razonables de abogados.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-text mb-4">6. Derechos de Terceros</h2>
              <p className="text-gray-700 leading-relaxed">
                Las disposiciones de los párrafos 3 (Uso del Servicio), 4 (Enlaces) y 5 (Indemnización) son para beneficio de SolterosMexico.com y su ejecutivos, directores, empleados, agentes, concesionarios, abastecedores y cualesquiera terceros proveedores de información al Servicio.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-text mb-4">7. Término; Terminación</h2>
              <p className="text-gray-700 leading-relaxed">
                Cualquiera de las partes podrá dar por terminado este Convenio sin previo aviso, en cualquier momento y por cualquier motivo; no obstante, usted ya no podrá usar el Servicio después de que haya dado por terminado este Convenio.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-text mb-4">8. Asuntos Varios</h2>
              <p className="text-gray-700 leading-relaxed">
                Todo este Convenio se regirá y se interpretará de acuerdo con las leyes del Estado de Texas que sean aplicables a los convenios celebrados y ejecutados en el Estado de Texas.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-text mb-4">9. Comunicaciones</h2>
              <p className="text-gray-700 leading-relaxed">
                Usted otorga a SolterosMexico.com el permiso de usar su dirección de email, dirección física, teléfono o cualesquiera medio de comunicación que Usted halla proporcionado para fines de contacto entre Usted y SolterosMexico.com, sus directivos, empleados y/o asociados.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-text mb-4">10. Cookies</h2>
              <p className="text-gray-700 leading-relaxed">
                Los proveedores de terceros, incluido Google, utilizan las cookies para publicar anuncios basándose en las visitas anteriores de un usuario a su sitio web. El uso de la cookie de DoubleClick permite a Google y a sus socios publicar anuncios basados en las visitas que los usuarios realizan en sus sitios o en otros sitios de Internet.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-text mb-4">Anexo A - Normas de Operación</h2>
              <div className="bg-blue-50 border-l-4 border-blue-400 p-4">
                <h3 className="text-lg font-semibold text-blue-800 mb-2">Reglas de Conducta:</h3>
                <ul className="list-disc list-inside text-blue-700 space-y-1">
                  <li>Debe usar su nombre real en comunicaciones en línea</li>
                  <li>Está prohibido publicar números telefónicos, cuentas de WhatsApp, correos electrónicos</li>
                  <li>Está prohibido publicar mensajes de odio, ofensivos o del tipo sexual</li>
                  <li>No puede colocar mensajes injuriosos, difamatorios o que revelen asuntos privados</li>
                  <li>No puede interferir con el uso del Servicio de otros usuarios</li>
                  <li>No puede colocar archivos que contengan virus o código destructivo</li>
                  <li>No puede enviar mensajes por correo electrónico no solicitados</li>
                </ul>
              </div>
            </section>

            <div className="bg-gray-50 p-6 rounded-lg mt-8">
              <h3 className="text-lg font-semibold text-gray-800 mb-2">Contacto</h3>
              <p className="text-gray-600">
                Si tiene preguntas sobre estos Términos de Uso, puede contactarnos a través de nuestro sitio web.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsOfUse;
